export const UpdateWebInfor = 'UpdateWebInfor'
export const UpdateLang = 'UpdateLang'
export const UpdateKpText = 'UpdateKpText'
export const UpdateConnState = 'UpdateConnState'
export const UpdateSyncState = 'UpdateSyncState'
export const UpdateLoading = 'UpdateLoading'
// export const UpdateViewState = 'UpdateViewState'
export const UpdateTableData = 'UpdateTableData'
export const UpdateData = 'UpdateData'
export const UpdateHeightApp = 'UpdateHeightApp'
export const UpdateHeightAppEff = 'UpdateHeightAppEff'
export const UpdateHeightToolbar = 'UpdateHeightToolbar'
export const UpdateMenu = 'UpdateMenu'
export const UpdateUserToken = 'UpdateUserToken'
export const UpdateUserSelf = 'UpdateUserSelf'
